/**
 * Compare two property-report search strings. Same house number on the same
 * street is a hit; a different street (18 Topaas vs 18 Galloway) is not.
 */
export function normalizeLsAddress(value) {
    return String(value || '')
        .toLowerCase()
        .replace(/^(lightstone\s+report|property\s+report)\s*-+\s*/i, '')
        .replace(/\.pdf\s*$/i, '')
        .replace(/,?\s*(south\s*africa|rsa|z\.?a\.?)\s*$/i, '')
        .replace(/[./#,]/g, ' ')
        .replace(/\b(street|st|avenue|ave|road|rd|drive|dr|lane|ln|close|crescent|cres|boulevard|blvd|way|place|pl)\b/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

function streetKey(value) {
    const n = normalizeLsAddress(value);
    const num = (n.match(/^(\d+[a-z]?)\b/) || [])[1] || '';
    const after = num ? n.slice(n.indexOf(num) + num.length).trim() : n;
    const street = after.split(' ').find((w) => /^[a-z]{3,}$/.test(w) || /^\d+(st|nd|rd|th)$/.test(w)) || '';
    return num && street ? `${num} ${street}` : n;
}

export function sameLightstoneAddress(a, b) {
  const na = normalizeLsAddress(a);
  const nb = normalizeLsAddress(b);
  if (!na || !nb) return false;
  if (na === nb) return true;
  const ka = streetKey(a);
  const kb = streetKey(b);
  return Boolean(ka && kb && ka === kb);
}

/** House number + street only — deeds lines carry suburb/province/postal after the street type. */
export function streetNumberNameOnly(address) {
  const rawQuery = String(address || '').trim();
  if (!rawQuery) return '';
  const q = rawQuery
    .replace(/,?\s*(south\s*africa|rsa|z\.?a\.?)\s*$/i, '')
    .replace(/^(\d+[A-Za-z]?),\s+/, '$1 ')
    .trim() || rawQuery;
  const m = q.match(
    /(\d+[A-Za-z]?)\s+([A-Za-z][A-Za-z']*(?:\s+(?:Street|St|Avenue|Ave|Road|Rd|Drive|Dr|Lane|Ln|Close|Crescent|Cres|Boulevard|Blvd|Way|Place|Pl))?)/i,
  );
  if (!m) return rawQuery;
  const street = `${m[1]} ${m[2]}`.replace(/\s+/g, ' ').trim();
  if (!street || street.toLowerCase() === q.toLowerCase()) return rawQuery;
  return street;
}
